<template>
  <div :class="['ride-map-toggle', { 'ride-map-toggle-column': inColumn }]">
    <button
      type="button"
      class="ride-map-toggle-button"
      :aria-expanded="value ? 'true' : 'false'"
      @click="$emit('input', !value)"
    >
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path fill="currentColor" d="M15 5.1 9 3 3 5v16l6-2.1 6 2.1 6-2V3l-6 2.1zM10 5.4l4 1.4v11.8l-4-1.4V5.4zM5 6.4l3-1v11.8l-3 1V6.4zm14 11.2-3 1V6.8l3-1v11.8z"/>
      </svg>
      {{ value ? t('hideRideMap') : t('showRideMap') }}
    </button>
    <div
      v-if="created"
      v-show="value"
      :class="inColumn ? 'trip-map-one' : 'ride-map-toggle-map'">
      <GlobalMap
        passed_class="ride_samery_map">
      </GlobalMap>
    </div>
  </div>
</template>

<script>
import GlobalMap from '@/components/GlobalMap';
import { translationMixin } from "@/mixins/translationMixin";

/**
 * The whole-ride map, behind a button: it waits for the traveller to ask.
 *
 * Use with v-model, so the layout owns whether it is open. Layouts start it open on
 * desktop and closed on mobile: see initialMapOpen. The map is not created
 * until first opened; when it is, GlobalMap's setAppMap replays the stay
 * markers that fetchRide stored (globalMap.js thisMapWereCreated). After that
 * it is only hidden and shown, never rebuilt.
 *
 * inColumn: the map sits in a side column at general.css's own size (the
 * classic summary on desktop), instead of full width under the button.
 */
export default {
  name: 'RideMapToggle',
  mixins: [translationMixin],
  components: { GlobalMap },
  props: {
    value: { type: Boolean, default: false },
    inColumn: { type: Boolean, default: false },
  },
  data() {
    return {
      created: this.value,
    };
  },
  watch: {
    value(open) {
      if (open) this.created = true;
    },
  },
};
</script>

<style scoped>
.ride-map-toggle {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin: 8px 0 32px;
}

.ride-map-toggle-column {
  align-items: stretch;
  margin: 16px 0;
}

.ride-map-toggle-column .ride-map-toggle-button {
  align-self: center;
}

.ride-map-toggle-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 22px;
  border: 0;
  border-radius: 999px;
  background: white;
  color: var(--primary-color, #07A0C3);
  box-shadow: inset 0 0 0 2px var(--primary-color, #07A0C3);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.ride-map-toggle-button:hover {
  transform: translateY(-1px);
  box-shadow: inset 0 0 0 2px var(--primary-color, #07A0C3), 0 4px 10px rgba(0, 0, 0, 0.12);
}

.ride-map-toggle-map {
  width: 100%;
}

/* general.css sizes this map for the old side column (86rem tall, an 80px
   margin under RTL); full width under the button it wants neither. */
.ride-map-toggle-map ::v-deep .ride_samery_map {
  height: min(65vh, 560px) !important;
  max-height: none;
  margin-left: 0 !important;
}
</style>
